const { ccclass } = cc._decorator;
import PlayerInfoSettingView from "./player_info_settingview";
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import ModelData from "../../../public/model_data";
import ModuleManager from "../../../../framework/core/module_manager";
import { fork } from "child_process";
import EventManager from "../../../../manager/event_manager";
import GameUtil from "../../../../utility/game_util";

@ccclass
@moduleInit("PlayerInfoSetting")
export default class PlayerInfoSetting extends ModuleBase<PlayerInfoSettingView, null>  {
    curShowType = null
    firstshow = true
    dataByType = []
    //服务器给的数据类型对应模块名称
    plizedTypeByModuleName: { [key: string]: string; } = { 
        'player_info':'PlayerInfoModule',
        "head_img":"IconEditor",
        "head_frame":"PlayerKuangSetting", 
        "card_icon":"PlayerPaibeiChoose",
    }

    plizedTypeByCode:{ [key: string]: string; } = { 
        "head_img":"",
        "head_frame":"", 
        "card_icon":"",
    }

    avatarUrl:string = ''
  
    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/hall/module/playerinfosetting/player_info_setting";
        this.viewType = PlayerInfoSettingView;
        this.modelType = null
        this.autoShowAnim = true
        this.needAnim = true
        this.needViewMask = true
        this.needDeferShow = true
    }

    onInit(intentData: any) {
        super.onInit(intentData);
        
    }

    onDeferShow(intentData) {
        this.bindEvent()
        this.firstshow = true
        this.curShowType = null
        this.onButtonClickName("GeRenBtn")
    }


    protected onButtonClickName(name : string) {
        switch (name) {
            case "CloseBtn":
                this.hide()
                break;
            case "GeRenBtn":
                this.changeShowView("player_info", "GeRenBtn")
                break;
            case "TouXiangBtn":
                this.changeShowView("head_img", "TouXiangBtn")
                break;
            case "KuangBtn":
                this.changeShowView("head_frame", "KuangBtn")
                break;
            case "PaiBtn":
                this.changeShowView("card_icon", "PaiBtn")
                break;
            default:
                break;
        }
    }

    //切换改变显示
    changeShowView(plizedType, btnName){
        if (this.curShowType == plizedType) { return }
        this.view.updateBtnChoose(btnName)
        let showBtn = btnName == "GeRenBtn"||btnName == 'TouXiangBtn'
        if (showBtn){
            this.dataByType['player_info'] = {};
            this.dataByType['head_img'] = {};
        }
        this.view.bgNode.active = btnName != "GeRenBtn";
        let self = this
        let  showview = function (data) {
            if (self.curShowType != null){
                ModuleManager.instance.hideModule(self.plizedTypeByModuleName[self.curShowType])
            }
            self.curShowType = plizedType
            let nowModule =  ModuleManager.instance.showModuleName(self.plizedTypeByModuleName[plizedType], data, ()=>{

            })
            nowModule.node.parent = self.view.childrenNode
            if (self.firstshow){
                self.show()
                self.firstshow = false
            }
        }
        if (this.dataByType[plizedType] == null ){
            this.getUserPlizedListData(plizedType, showview)
        }
        else{
            showview(this.dataByType[plizedType])
        }
    }

    //通过个性化类型获取数据
    getUserPlizedListData(plizedType, callBack){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "plized/getUserPlizedList?",
            params: {
                plizedType: plizedType,
                gameUserId:ModelData.instance.roleData.id,
            },
            showNetPrompt: true,
        }
        this.apiHttpGet(requestData, function (respone) {
            let datalist = []
            for (let index = 0; index < respone.data.length; index++) {
                const element = respone.data[index];
                if (element.plizedCode == "empty"){
                    datalist.splice(0, 0, element)
                }
                else{
                    datalist.push(element)
                }
                
            }
            self.dataByType[plizedType] = datalist
            if (callBack != null){
                callBack(datalist)
            }
        })
    }

    updateUserPlizedListData(plizedType, data){
        this.dataByType[plizedType] = data
    }


    updateLocalCode(itemData){
        this.plizedTypeByCode[itemData.plizedType] = itemData.plizedCode
    }

    changeAllCode(){
        for (const key in this.plizedTypeByCode) {
            if (this.plizedTypeByCode.hasOwnProperty(key)) {
                const code = this.plizedTypeByCode[key];
                let oldcode = ""
                let callback = null
                switch(key){
                    case "head_img":
                        oldcode = ModelData.instance.roleData.plizedHeadImg
                        callback = function(plizedCode){
                            ModelData.instance.roleData.plizedHeadImg = plizedCode
                        }
                        break;
                    case "head_frame":
                        oldcode = ModelData.instance.roleData.plizedHeadFrame
                        callback = function(plizedCode){
                            ModelData.instance.roleData.plizedHeadFrame = plizedCode
                            EventManager.instance.dispatch('player_avatar_data_changed', ModelData.instance.roleData.id, true) //通知别的地方 更新头像框
                        }
                        break;
                    case "card_icon":
                        oldcode = ModelData.instance.roleData.plizedCardIcon
                        callback = function(plizedCode){
                            ModelData.instance.roleData.plizedCardIcon = plizedCode
                            EventManager.instance.dispatch('Event_Update_PaiBei', ModelData.instance.roleData.id, true) //通知别的地方 更新头像框
                        }
                        break;
                    default:
                        break;
                }
                if (code != "" && oldcode != code){
                    this.checkPlized(key, code, callback)
                }
                
            }
        }
    }

    onHide(){
        this.changeAllCode()
        ModuleManager.instance.hideModule(this.plizedTypeByModuleName[this.curShowType])
        this.eventUnBind("Event_Update_PlizedListData", this.updateUserPlizedListData)
        this.eventDispatch('_on_hide_playerInfo_')
    }

    //切换选择
    checkPlized(plizedType, plizedCode, callBack){ 
        let requestData: IHttpRequestData = {
            baseUrl: "plized/checkPlized?",
            params: {
                plizedType: plizedType,
                plizedCode:plizedCode,
                gameUserId:ModelData.instance.roleData.id,
            },
        }
        GameUtil.apiHttpGet(requestData, () => {
            if (callBack != null){
                callBack(plizedCode)
            }
        })
    }

    private bindEvent() {
        this.eventBind("Event_Update_PlizedListData", this.updateUserPlizedListData)
        this.eventBind("Event_Update_Local_Plized", this.updateLocalCode)
    }

}